import React, { useEffect, useState } from "react";
import st from "../../style.module.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, Row, Col, Modal } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import { useFieldArray, useForm } from "react-hook-form";
import cx from "./DynamicForm.module.scss";
import { CircularProgress } from "@mui/material";
import { deleteQuestionApi, getQuestionApi, postQuestionApi } from "../../services/Question";
import QuestionBody from "./QuestionBody";


function AddDynamicForm({ type }) {

  const [getQueResData, setQueResData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    control,
    setValue,
    getValues,
  } = useForm();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "form",
  });

  const [getDeleteInfo, setDeleteInfo] = useState({});
  const [userDeleteModel, setIsDeleteModel] = useState(false);
  const setUserDeleteCloseModel = () => {
    setDeleteInfo({});
    setIsDeleteModel(false);
  };

  const deleteModel = (queData, index) => {
    setDeleteInfo({
      queData: queData,
      index: index,
    });
    setIsDeleteModel(true);
  };

  const deleteItemQue = async (queData, index) => {
    const queId = getQueResData?.filter(
      ({ question }) => question === queData?.question
    )[0]?.id;
    if (queId) {
      setIsLoading(true);
      try {
        const response = await deleteQuestionApi(queId, getProductList, setUserDeleteCloseModel)
        if (response.ok) {
          getProductList();
          setUserDeleteCloseModel();
        }
      } catch (error) {
        console.error(error, "Error submitting form:");
      }
    } else {
      remove(index);
      setUserDeleteCloseModel();
    }
  };

  const getProductList = async () => {
    setIsLoading(true);
    try {
      const data = await getQuestionApi();
      reset({ form: data });
      setQueResData(data);
    } catch (error) {
      console.error("Error fetching product data:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProductList();
  }, []);

  const onSubmit = async ({ form }) => {
    try {
      await postQuestionApi(form);
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        getProductList();
      }, 2000);
    }
  };

  return (
    <section className={`marginTopMobile ${st.pageWrapper} py-lg-3 py-md-2`}>
      {isLoading && (
        <CircularProgress
          className="position-fixed"
          style={{ top: "45%", right: "50%" }}
        />
      )}

      <div className={`${st.pageWrapperInside}`}>
        <Card>
          <Card.Body>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row className="py-3">
                <Col md={12}>
                  <h3 className="fw-bold mb-3">Questionnaire</h3>
                </Col>
                <Col md={11}>
                  {fields.map((item, index) => (
                    <div
                      key={index}
                      className={`position-relative ${st.contentBox}`}
                    >
                      <QuestionBody index={index}
                        {...{ errors, register, watch, control, getValues, index, setValue }}
                      />
                      <hr />
                      <Row>
                        <Col lg={12}>
                          {watch(`form.${index}.fieldType`)?.value !==
                            "decision-tree" && (
                              <div
                                className={`${st.box_bottom_btnDiv} ${cx.deleteButton}`}
                                onClick={() => deleteModel(item, index)}
                              >
                                <div className={`${st.delete_box}`}>
                                  <button type="button" className={`btn`}>
                                    <MdDelete />
                                  </button>
                                </div>
                              </div>
                            )}
                        </Col>
                      </Row>
                    </div>
                  ))}
                  <button
                    className={`btn text-white ${st.btnDisabled}`}
                    type="submit"
                  >
                    Submit
                  </button>
                </Col>
                <Col md={1}>
                  <div
                    className={`${st.sideBtna_showHide}`}
                    onClick={() =>
                      append({
                        fieldType: "",
                        question: "",
                        nestedOptions: [],
                      })
                    }
                  >
                    <span>
                      <button type="button" className="btn">
                        <FiPlusCircle />
                        Add more
                      </button>
                    </span>
                  </div>
                </Col>
              </Row>
            </form>
          </Card.Body>
        </Card>
      </div>

      <Modal
        centered
        show={userDeleteModel}
        onHide={() => {
          setUserDeleteCloseModel();
        }}
        style={{ display: "block" }}
      >
        <Modal.Body className="modal-body">
          <div className="deadline-form">
            <h4
              style={{
                textAlign: "center",
                fontSize: "22px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              Are you sure to delete this Question?
            </h4>
            <div
              className={`${st.modalButtonBottom} d-flex justify-content-between`}
            >
              <button
                onClick={() => {
                  setUserDeleteCloseModel();
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  deleteItemQue(getDeleteInfo?.queData, getDeleteInfo?.index);
                }}
                type="button"
                className="btn btn-primary"
              >
                yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}
export default AddDynamicForm;